import React from 'react';
import { QueryFactory } from '../../services/api';
import { UserRole } from '../../services/api/api-client.types.ts';
import { Loading } from '../../components/uikit/suspense/Loading.tsx';
import ForbiddenErrorPage from '../../pages/unauthorized/errorPages/ForbiddenErrorPage.tsx';
import { NoRolesErrorPage } from '../../pages/unauthorized/errorPages/NoRolesErrorPage.tsx';
import { all } from '../../application/constants/allowed-roles.ts';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: UserRole[] | typeof all;
}

const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
  const userQuery = QueryFactory.UserQuery.useGetCurrentUserInfoQuery();
  const userRoles = userQuery.data?.claimRoles ?? [];
  const hasAccess =
    allowedRoles === all ||
    !!userRoles?.some((role) => allowedRoles.includes(role));

  if (userQuery.isLoading) {
    return <Loading loading={userQuery.isLoading} />;
  }

  if (userQuery.isFetched) {
    if (!userRoles.length) {
      return <NoRolesErrorPage />;
    }

    if (!hasAccess) {
      return <ForbiddenErrorPage />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
